module.exports = __webpack_public_path__ + "img/2-2.eb5e97d0.png";